import { Component, OnInit, Input, ViewChild } from '@angular/core';
//import { FormControl, Validators } from '@angular/forms';
import { ViewEncapsulation } from '@angular/core';
import { User } from '../User';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router, ParamMap } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogClose } from '@angular/material';
import { AuthenticationService } from '../authentication.service';
import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, WebStorageService } from 'angular-webstorage-service';
import { ApiService } from '../api.service';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import { LoginSignupModalComponent } from '../login-signup-modal/login-signup-modal.component';
import { AlertService } from '../alert.service';
import { ModalDirective } from 'angular-bootstrap-md';
class signUpUserObj {
  fName: string = "";
  lName: string = "";
  gender:number = 1 ;
  signUpType: "generic";
  mobile: string = "";
  email: string = "";
  password: string = "";
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}

class signinUsrObj {
  username: string = "";
  password: string = "";
  constructor(values: Object = {}) {
    //Constructor initialization
    Object.assign(this, values);
  }
}


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  @ViewChild('basicModal') basicModal: ModalDirective;
  @ViewChild('OTPModal') OTPModal: ModalDirective;
  @ViewChild('forgotPasswordModal') forgotPasswordModal: ModalDirective;
  

  show1: boolean = false;
  show2: boolean = true;

  public show: boolean = true;
  public buttonName: any = 'Sign Up';

  loginAlert: string;
  loginError: boolean = false;

  buttonText: string;  // to show the message in login/signup buton
  private debugData: Boolean = false;  // to show and hide the data in console log
  private user: User;  // to store the values of user object return from server
  private userSignUpData: signUpUserObj; // to store the values of signup form
  private userSigninData: signinUsrObj; // to store values of signin form data
  otpErrorMsg: string = ""; // to display the error msg on otp popup
  emailResetMsg: string = ""; // to display the error msg in email reset popup
  SignUpmsg: string = ""; // to display the signup msg in signup form html
  SignInmsg: string = ""; // to display the error msg in sign in form html

  toggle() {
    this.show1 = !this.show1;
  }
 
  toggleH() {
    this.show = !this.show;
    // CHANGE THE NAME OF THE BUTTON.
    if (this.show)
      this.buttonName = "Sign Up";
    else
      this.buttonName = "Login";
  }

  constructor(private httpClient: HttpClient, private route: ActivatedRoute, private router: Router,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService, private authenticationservice: AuthenticationService,
    private alertService: AlertService, private apiService: ApiService) {

    this.initCustData();
    this.userSigninData = new signinUsrObj();
    this.userSignUpData = new signUpUserObj();
    if (this.debugData == true) {
    //    console.log(this.userSignUpData);
    }
  }

  ngOnInit() {
    
  }

  initCustData() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let urrr = this.apiService.cutomerDetails + this.apiService.getFromLocalData('custDD');
      this.httpClient.get(urrr)
        .subscribe(
          data => this.intilizeComponent(data),
          error => this.showError(error)
        );
    } else {
      this.buttonText = "Login/Signup";
      if (this.debugData == true) {
        //console.log("User Not Logged In. Please login!")
      }
    }
  }

  intilizeComponent(data) {
    if (this.debugData == true) {
      //console.log("Customer already logged in");
      //console.log(data);
    }
    this.user = data;
    this.buttonText = "Hi " + this.user.fName;
  }

  checkUserLoginStatus(): boolean {
    if (this.apiService.checkUserLoggedIn() == true) {
      return true;
    } else {
      this.buttonText = "Login/Signup";
      return false;
    }
  }



  showError(msg) {
    this.warn("Some Error Occured please try again");
  }

  // <!-- Start of sign in function -->
  public onFormLogin({ value, valid }: { value: signinUsrObj, valid: boolean }) {
    this.userSigninData = value;
    if (this.debugData) {
      //console.log("Sign In Function data")
      //console.log(this.userSigninData);
    }
    this.httpClient.post(this.apiService.LoginURL, this.userSigninData)
      .subscribe((data: any) => {
        if (this.debugData == true) {
         // console.log("Customer Login API data");
          //console.log(data);
        } 
        if (data.success == "true") {
          if (this.debugData == true) {
            //console.log("Customer id : " + data.customer.id);
            //console.log("Customer Name : " + data.customer.fName);
          }
          this.success("Successfully logged in");
          this.SignInmsg = "Sign In Sucessfull";
          this.storage.set('custDD', data.customer.id);
          this.storage.set('Name', data.customer.fName);
          this.buttonText = "Hi" + data.customer.fName;
          
          this.router.navigate(['/model']);
         this.refresh();
         window.location.href="https://book.on-track.in/model";
        } else {
         // this.success("Login failed");
          this.SignInmsg = " Sign in failed try again";
        }
      });
  }
  // <!-- End of sign in function -->


  genderNow:number = 1; // 1 for male and 0 for female , by default keep it as male
  changeGender(valueGender:number){
    this.genderNow = valueGender;
    if(this.debugData){
      console.log("Selected gender is ");
      console.log(this.genderNow);
    }
  }

  // <!-- Start of sign up function -->
  public onFormSubmit({ value, valid }: { value: signUpUserObj, valid: boolean }) {
    this.userSignUpData = value;
    this.userSignUpData.signUpType = "generic";
    this.userSignUpData.gender = this.genderNow;
    if (this.debugData) {
      console.log("User SignUp Data");
      console.log(this.userSignUpData);
    } 
    this.httpClient.post(this.apiService.signupURL, this.userSignUpData)
      .subscribe(
        (dataSignup: any) => {
          if (this.debugData) {
           console.log("signup form function api data");
            console.log(dataSignup);
          }
          if (dataSignup.status == true) {
            this.SignUpmsg = "Signup Successfully";
            this.user = dataSignup.obj;
            console.log("HelloDDDDD");
            console.log(this.user);
            this.storage.set('custDD', this.user.id);
            this.storage.set('Name', this.user.fName);
            this.buttonText = this.user.fName;
            this.OTPModal.show();
            //this.refresh();
            //this.router.navigate(['/model']);
          } else {
            this.SignUpmsg = "Some Error Occured Please try again";
          }
        },
        (err) => {
          let errorD = err.error.message;
          if (errorD.indexOf("mobile") != -1) {
            this.SignUpmsg = "Mobile number already exist";
          } else if (errorD.indexOf("email") != -1) {
            this.SignUpmsg = "Email address already exist";
          }
        });
  }
  // <!-- end of sign up function -->

  // <!-- start of OTP verify function  -->
  verifyOtpN(otpToVerify) {
    let postData = { 'mobile': this.user.mobile, 'otp': otpToVerify }
    if (this.debugData) {
      console.log("very otp json data is ")
      console.log(postData);
    }
    this.httpClient.post(this.apiService.verifyOTP_URL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("very otp function API Data ")
            console.log(detail);
          }
          if (detail.status == true) {
            if (this.debugData) {
              console.log("Success OTP Verified")
            }
            this.user = detail.obj;
            this.otpErrorMsg = "OTP Verified";
            this.refresh();
          } else {
            if (this.debugData) {
              console.log(" OTP not Verified")
            }
            this.otpErrorMsg = "Incorrect OTP";
          }
        }
      )
  }
  // <!-- end of OTP verify function  -->

  // <!-- Start of OTP send function  -->
  sendOtpN(mobileNumber, custId) {
    let postData = { 'mobile': mobileNumber, 'id': custId };
    this.httpClient.post(this.apiService.sendOtpURL, postData)
      .subscribe(
        (detail: any) => {
          if (this.debugData) {
            console.log("Send OTP Api data");
            console.log(detail);
          }
          if (detail.status == true) {
            return true;
          } else {
            return false;
          }
        }
      )
  }
  // <!-- end of OTP send function  -->

  // <!-- start of OTP Resend function  -->
  resendOtpNow() {
    if (this.apiService.checkUserLoggedIn() == true) {
      let postData = { 'mobile': this.user.mobile };
      this.httpClient.post(this.apiService.resendURL, postData)
        .subscribe(
          (detail: any) => {
            if (this.debugData) {
              console.log("resend otp function API data");
             console.log(detail);
            }
            if (detail.status == true) {
              this.otpErrorMsg = "OTP sent"
            } else {
              this.otpErrorMsg = "OTP sending fail"
            }
          },
          (err) => {
            this.otpErrorMsg = "Some error occured. Please try again."
          });
    } else {
      this.warn("Please Login");
    }
  }
  // <!-- end of OTP Resend function  -->

  refresh(): void {
    window.location.reload();
  }

  logout() {
    this.storage.remove('custDD');
    this.apiService.saveInLocalData(this.user.id, null);
    this.apiService.saveInLocalData(this.user.fName, null);
    this.buttonText = "Login/Signup";
    this.router.navigate(['/model']);
  }

  // <!-- Start of reset password link function -->
  resetPwd(emailVal: string) {
    let getResetData = { "email": emailVal };
    this.httpClient.post(this.apiService.postsURL + 'resetPassword', getResetData)
      .subscribe(
        (reset: any) => {
          if (this.debugData) {
            console.log("Email Reset function");
            console.log(reset);
          }
          if (reset.status == true) {
            this.emailResetMsg = "Link sent successfully";
            this.forgotPasswordModal.hide();
            return true;
          } else {
            this.emailResetMsg = "Please enter valid email id";
            return false;
          }
        },
        (err) => {
          this.emailResetMsg = "Some error occured. Please try again."
        });
  }
  // <!-- End of reset password link function -->

  success(message: string) {
    this.alertService.success(message);
  }

  error(message: string) {
    this.alertService.error(message);
  }

  info(message: string) {
    this.alertService.info(message);
  }

  warn(message: string) {
    this.alertService.warn(message);
  }

  clear() {
    this.alertService.clear();
  }
  
}



// WEBPACK FOOTER //
// C:/unnati/latestWebCode29march/src/app/login/login.component.ts